import { TranslationService } from '../../../services/translation.service';
import arrowRotateLeftIcon from '../../../../assets/icons/arrow-rotate-left.svg';
import DataUrlHelper from '../../../helpers/data-url.helper';
import './style.scss';

const translationClearFilters = TranslationService.get('common.clear');

function ClearButtonComponent({ onClick }: { onClick: () => void }) {
  return (
    <button type="button" className="btn--as-text clear-button-with-icon d-flex align-items-center" onClick={onClick}>
      <img src={DataUrlHelper.encode(arrowRotateLeftIcon)} alt="" className="me-1 h-100" />
      {translationClearFilters}
    </button>
  );
}

export default ClearButtonComponent;
